'use client';

import { isValidUserRole, useSession } from '@repo/auth';
import { useEffect, useRef } from 'react';
import { ga4GtagAdapter } from '../ga4-gtag-adapter';

export function useIdentifyUser(): void {
  const { data: session } = useSession();
  const identifiedForRef = useRef<string | null>(null);

  useEffect(() => {
    const user = session?.user;
    if (!user?.id) {
      return;
    }
    if (identifiedForRef.current === user.id) {
      return;
    }
    identifiedForRef.current = user.id;

    const role = user.role;
    const isStaff = typeof role === 'string' && isValidUserRole(role);

    ga4GtagAdapter.identify(user.id);
    ga4GtagAdapter.setUserProperty('logged_in', 'true');
    ga4GtagAdapter.setUserProperty('user_role', isStaff ? role : 'user');
    ga4GtagAdapter.setUserProperty('traffic_type', isStaff ? 'internal' : 'external');
  }, [session]);
}
